import api from '@/apis/dashboard/dashboardResultActivityAPI';
import Chart from '@/stores/baseChart';
const chart = new Chart('resultActivity', api);

const state = {
  ...chart.state,
  colors: ['#0dbab6', '#ecbb4c', '#0eac13', '#ec6666'],
  categorieDatas: ['Doanh thu', 'Chi phí', 'Thặng dư', 'Thâm hụt'],
};
const getters = {
  ...chart.getters,
};
const actions = {
  ...chart.actions,
};
const mutations = {
  ...chart.mutations,
  /**
   * Set items
   * @param {*} state state
   * @param {*} data data
   * HTHIEP 21.06.2023
   */
  setItems(state, data) {
    let dataCustom = [];
    let colors = [];
    let categorieDatas = [];
    if(data && (data.Revenue != 0 || data.Expense != 0 || data.Excess != 0 || data.Deficit != 0) )
    {
      
      let datas = [data.Revenue,data.Expense,data.Excess,data.Deficit];
      datas = datas.filter(x => (x != 0 && x != null && x != undefined));
      dataCustom = [{data:datas}];
    }
    // gán dữ liệu load lên biểu đồ
    state.items = dataCustom;

    if(data.Revenue != null && data.Revenue != 0)
    {
      colors.push('#0dbab6');
      categorieDatas.push('Doanh thu');
    }

    if(data.Expense != null && data.Expense != 0)
    {
      colors.push('#ecbb4c');
      categorieDatas.push('Chi phí');
    }

    if(data.Excess != null && data.Excess != 0)
    {
      colors.push('#0eac13');
      categorieDatas.push('Thặng dư');
    }

    if(data.Deficit != null && data.Deficit != 0)
    {
      colors.push('#ec6666');
      categorieDatas.push('Thâm hụt');
    }

    // gán color và categories
    state.colors = [...colors];
    state.categorieDatas =  [...categorieDatas];
  },
};

export default {
  // eslint-disable-next-line no-undef
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
